import { Icon, IconButton, Stack, Title, Tooltip } from "@introist/react-foundation/v2";
import { List, ListRow } from "components/organisms/List";
import { api } from "services/rpc/RpcProvider";

interface TaskAssignment {
  taskId: string;
  assignmentId: string;
  completed: boolean;
}

interface Props {
  taskAssignments: TaskAssignment[];
}

const truncateString = (str: string, maxLength: number = 25): string => {
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + "...";
};

export const TaskAssignmentViewer = ({ taskAssignments }: Props) => {
  const { data: tasks } = api.tasks.list.useQuery({});

  const getTaskTitle = (taskId: string) => {
    const task = tasks?.find(t => t.id === taskId);
    return task?.title ?? "Unknown Task";
  };

  return (
    <List>
      {taskAssignments.map(assignment => {
        const fullTitle = getTaskTitle(assignment.taskId);
        const displayTitle = truncateString(fullTitle, 25);
        const isTruncated = fullTitle.length > 25;

        return (
          <ListRow key={assignment.assignmentId} gridTemplateColumns="1fr auto auto">
            {/* Column 1: Task title */}
            {isTruncated ? (
              <Tooltip tooltip={fullTitle}>
                <Title variant="bold">{displayTitle}</Title>
              </Tooltip>
            ) : (
              <Title variant="bold">{displayTitle}</Title>
            )}

            {/* Column 2: Status */}
            {assignment.completed ? (
              <Stack gap="xSmall">
                <Icon name="check" />
                <Title variant="bold">Completed</Title>
              </Stack>
            ) : (
              <Title>Pending</Title>
            )}

            {/* Column 3: Link to task detail page */}
            <IconButton
              size="small"
              variant="blended"
              icon="moveTo"
              onClick={() => window.open(`/tasks/${assignment.taskId}`, "_blank")}
            />
          </ListRow>
        );
      })}
    </List>
  );
};
